import {FormattedMessage, useIntl} from "react-intl";
import React from "react";
import PrivateImage from "@components/PrivateImage";
import Toggle from "@ui-components/Toggle";
import {ImagesEditorProps} from "./types";
import Alert from "@ui-components/Alert";
import Placeholder from "@ui-components/Placeholder";

export const ImagesEditor = ({
  images,
  includedImages,
  setIncludedImages,
  coverImage,
  setCoverImage,
  hasDoublePrices,
  targetPrice,
  setTargetPrice,
}: ImagesEditorProps) => {

  const intl =  useIntl();

  const kcolorPriceChoiceComponent = hasDoublePrices !== false ? (
    <div className="col-span-full mt-4">
      {hasDoublePrices === undefined && <Placeholder width="w-full" height="h-20" marginClass=""/>}
      {hasDoublePrices === true && (
        <Alert
          type="info"
          title={intl.formatMessage({
            id: "select_kcolor_price_alert_title",
            defaultMessage: "Presenza di prezzi Kerakoll Colors",
          })}
          text={intl.formatMessage({
            id: "select_kcolor_price_alert_text",
            defaultMessage: "È stata rilevata la presenza di prezzi Kerakoll Colors in uno o più configuratori selezionati. Utilizzando il toggle sottostante, è possibile scegliere se generare il report con i prezzi pubblici o con i prezzi tintometro.",
          })}
        >
          {/* @ts-ignore */}
          <div className="flex flex-row gap-2 items-center text-xs font-medium mt-1">
                <span className="leading-tight">
                  <FormattedMessage id="public_price" defaultMessage="Prezzo pubblico"/>
                </span>
            {/* @ts-ignore */}
            <Toggle
              checked={targetPrice === "tintometer"}
              onChange={() => setTargetPrice((prev) => prev !== "tintometer" ? "tintometer" : "kerakoll")}
              marginCls=""
            />
            <span className="leading-none">
                  <FormattedMessage id="tintometer_price" defaultMessage="Prezzo tintometro"/>
                </span>
          </div>
        </Alert>
      )}
    </div>
  ) : null;

  if (!images?.length)
    return (
      <div className="w-full h-96 flex flex-col items-center justify-center gap-1 p-4 text-center">
        <p className="text-base font-medium">
          <FormattedMessage id="no_available_images" />
        </p>
        <p>
          <FormattedMessage id="no_available_images_helper" />
        </p>
        <div className={"justify-center mt-4"}>
        {kcolorPriceChoiceComponent}
        </div>
      </div>
    );

  return (
    <div className="grid grid-cols-6 gap-2">
      <div className="col-start-5 col-span-1 text-center text-xxs">
        <FormattedMessage id="cover" />
      </div>
      <div className="col-span-1 text-center text-xxs">
        <FormattedMessage id="include" />
      </div>
      {images?.map(({image_url: url, des_image: description}, idx) =>
        <React.Fragment key={idx}>
          <div className="col-span-4 flex gap-4 items-center">
            <div className="w-20 h-auto bg-gray-100">
              {/* @ts-ignore */}
              <PrivateImage
                tag="div"
                image_url={url}
                alt={description}
              />
            </div>
            <p className={!description ? "text-gray-400" : "font-medium"}>
              {description || <FormattedMessage id="no_description" defaultMessage="Nessuna descrizione" />}
            </p>
          </div>
          <div className="col-span-1 flex justify-center">
            <Toggle
              label={undefined}
              description={undefined}
              checked={coverImage === url}
              onChange={() => {
                setCoverImage((prev) => prev !== url ? url : null);
              }}
              marginCls="mt-1"
              vertical={false}
            />
          </div>
          <div className="col-span-1 flex justify-center">
            <Toggle
              label={undefined}
              description={undefined}
              checked={includedImages?.has(url)}
              onChange={() => {
                setIncludedImages((prev) => {
                  const local = new Set(prev);
                  if (local.has(url)) local.delete(url);
                  else local.add(url);
                  return local;
                })
              }}
              marginCls="mt-1"
              vertical={false}
            />
          </div>
        </React.Fragment>
      )}
      {kcolorPriceChoiceComponent}
    </div>
  )
}